<template>
  <div class="n2-pagina" ref="raiz">
    <N2CabezaPagina :titulo="titulo" :subtitulo="P.Subtitulo?.Texto" :imagen="P.Imagen" :filtro="P.ImagenFiltro"
      :boton="P.ShowButton ? P.Button : null" />

    <section class="n2-seccion n2-seccion--pagina">
      <div class="n2-contenedor">
        <!-- Agrupado por categoría (panel: Equipo → Categoría) y en el orden de "Posición" -->
        <div v-for="g in grupos" :key="g.categoria" class="n2-grupo">
          <h2 v-if="g.categoria" class="n2-grupo__titulo n2-aparece">{{ g.categoria }}</h2>
          <div class="n2-lista n2-lista--personas" :class="{ 'n2-lista--una': columnas === 1 }" :style="{ '--n2-columnas': columnas }">
            <article v-for="m in g.miembros" :key="m.id" class="n2-perfil n2-perfil--tarjeta n2-aparece" :class="{ 'n2-perfil--sin-foto': !m.Imagen }">
              <figure v-if="m.Imagen" class="n2-perfil__foto">
                <img :src="imagenIDtoSRC(m.Imagen)" :alt="'Fotografía de ' + m.Nombre" loading="lazy" />
              </figure>
              <div class="n2-perfil__texto">
                <h3 v-if="m.Nombre" class="n2-perfil__nombre">{{ m.Nombre }}</h3>
                <p v-if="m.Puesto" class="n2-perfil__puesto">{{ m.Puesto }}</p>
                <div v-if="m.Descripcion" class="n2-texto-rico" v-html="conSaltos(m.Descripcion)"></div>
                <div v-if="m.Email || m.Extension" class="n2-perfil__datos">
                  <a v-if="m.Email" :href="'mailto:' + m.Email"><v-icon size="17">mdi-email-outline</v-icon> {{ m.Email }}</a>
                  <a v-if="m.Extension" :href="'tel:' + (C.Telefono ? C.Telefono.replace(/\s/g, '') + ',' : '') + m.Extension">
                    <v-icon size="17">mdi-phone-outline</v-icon> Ext. {{ m.Extension }}
                  </a>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>

    <SolicitudAccesoPagina origen="equipo" />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { tituloSeccion, conSaltos, columnasPanel, useAparicion } from '../../composables/useNotaria2'
import N2CabezaPagina from './N2CabezaPagina.vue'

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { imagenIDtoSRC, $t } = useUtils()
const raiz = ref(null)
useAparicion(raiz)

// Panel: Diseño páginas → Equipo (cabecera y columnas) y los miembros de Equipo
const P = computed(() => NOTARIA.value?.Theme?.Team ?? {})
const C = computed(() => NOTARIA.value?.Contacto ?? {})
const titulo = computed(() => P.value.Titulo?.Texto || tituloSeccion(NOTARIA.value, 'Equipo', $t))
const columnas = computed(() => columnasPanel(P.value.NumeroColumnas))

// Mismo orden que la página de siempre: primero los que tienen posición (de menor a mayor), luego el resto
const grupos = computed(() => {
  const equipo = NOTARIA.value?.Team ?? []
  const conPosicion = equipo.filter(m => m.Posicion !== undefined && m.Posicion !== null).sort((a, b) => a.Posicion - b.Posicion)
  const ordenados = conPosicion.length ? [...conPosicion, ...equipo.filter(m => !conPosicion.includes(m))] : equipo
  const lista = []
  for (const m of ordenados) {
    const categoria = String(m.Categoria || '').trim()
    let g = lista.find(x => x.categoria === categoria)
    if (!g) lista.push(g = { categoria, miembros: [] })
    g.miembros.push(m)
  }
  return lista
})
</script>
